function updateBstCartUpsellNav(root) {
  if (!root) return;

  const track = root.querySelector('[data-bst-cart-upsell-track]');
  const prevButton = root.querySelector('[data-bst-cart-upsell-prev]');
  const nextButton = root.querySelector('[data-bst-cart-upsell-next]');

  if (!track || !prevButton || !nextButton) return;

  const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
  const current = track.scrollLeft;
  const hasOverflow = maxScroll > 0;

  prevButton.disabled = !hasOverflow || current <= 1;
  nextButton.disabled = !hasOverflow || current >= maxScroll - 1;
}

function bindBstCartUpsellTracks(root) {
  if (!root) return;

  root.querySelectorAll('[data-bst-cart-upsell-track]').forEach((track) => {
    if (track._bstCartUpsellScrollHandler) {
      track.removeEventListener('scroll', track._bstCartUpsellScrollHandler);
    }

    track._bstCartUpsellScrollHandler = () => updateBstCartUpsellNav(root);
    track.addEventListener('scroll', track._bstCartUpsellScrollHandler, { passive: true });
  });

  updateBstCartUpsellNav(root);
}

function initBstCartDrawerUpsells(scope = document) {
  const roots =
    scope instanceof Element && scope.matches('[data-bst-cart-upsell]')
      ? [scope]
      : scope.querySelectorAll
        ? scope.querySelectorAll('[data-bst-cart-upsell]')
        : document.querySelectorAll('[data-bst-cart-upsell]');

  roots.forEach((root) => bindBstCartUpsellTracks(root));
}

function setupBstCartUpsellDelegation() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer || cartDrawer.dataset.bstUpsellDelegated === 'true') return;

  cartDrawer.dataset.bstUpsellDelegated = 'true';

  cartDrawer.addEventListener('click', (event) => {
    const prevButton = event.target.closest('[data-bst-cart-upsell-prev]');
    const nextButton = event.target.closest('[data-bst-cart-upsell-next]');
    if (!prevButton && !nextButton) return;

    const root = event.target.closest('[data-bst-cart-upsell]');
    const track = root?.querySelector('[data-bst-cart-upsell-track]');
    const button = prevButton || nextButton;

    if (!root || !track || button.disabled) return;

    track.scrollBy({
      left: prevButton ? -track.clientWidth : track.clientWidth,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  });

  if (!window._bstCartUpsellResizeHandler) {
    window._bstCartUpsellResizeHandler = () => initBstCartDrawerUpsells();
    window.addEventListener('resize', window._bstCartUpsellResizeHandler, { passive: true });
  }
}

function observeBstCartDrawerRecommendations(scope = document) {
  scope.querySelectorAll('.bst-cart-drawer__recommendations').forEach((element) => {
    if (element._bstRecommendationsObserved) return;
    element._bstRecommendationsObserved = true;

    const observer = new MutationObserver(() => {
      const upsellRoot = element.closest('[data-bst-cart-upsell]');
      bindBstCartUpsellTracks(upsellRoot);
    });

    observer.observe(element, { childList: true, subtree: true });
  });
}

function initBstCartDrawer(scope = document) {
  setupBstCartUpsellDelegation();
  initBstCartDrawerUpsells(scope);
  observeBstCartDrawerRecommendations(scope);
}

window.initBstCartDrawer = initBstCartDrawer;

document.addEventListener('DOMContentLoaded', () => initBstCartDrawer());

document.addEventListener('shopify:section:load', (event) => initBstCartDrawer(event.target));

if (window.PUB_SUB_EVENTS && typeof subscribe === 'function') {
  subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => {
    window.setTimeout(() => initBstCartDrawer(), 0);
  });
}
